import { createAction, props } from "@ngrx/store";
import { InsurerDto } from "src/app/api/models";

export const loadInsurerList = createAction("[Insurer] Load Insurers");
export const loadInsurerListSuccess = createAction("[Insurer] Load Insurers Success", props<{ data: InsurerDto[] }>());
export const loadInsurerListFailure = createAction("[Insurer] Load Insurers Failure", props<{ error: any }>());

export const loadInsurerParams = createAction("[Insurer] Load insurer params", props<{ insurerId: string, langCode:string }>());
export const loadInsurerParamsSuccess = createAction("[Insurer] Load insurer params success");
export const loadInsurerParamsFailure = createAction("[Insurer] Load insurer params failure",props<{ error: any }>());

export const resetInsurer = createAction("[Insurer] Reset");